<app-section #parentSection
             [title]="title"
             [key]="key"
             class="selected-offer-section"
             [ngClass]="{'selected-offer-section--next': isNext}"
             [formConfig]="formConfig"
             [sectionRef]="section"
             [formGroup]="formGroup">

  <ng-template #section>

    <app-offer-selected-item *ngIf="!isCarOne"></app-offer-selected-item>
      <app-next-offer *ngIf="isCarOne"
                      [offer]="selectedOfferService.selectedOffer"
                      (showDetails)="offersSectionStateService.showOfferDetails(selectedOfferService.selectedOffer, false)"
      ></app-next-offer>

  </ng-template>
</app-section>

<app-driver-sos-details-banner *ngIf="bannerVisible"></app-driver-sos-details-banner>
